import Api from '@/helpers/api';
/**
 * Obtiene la lista de Claves
 *
 * @returns {Promise<KeyChains>} Promise - una promesa con la lista de Claves // Error
 */
const getAllKeys = async () => {
    const result = await Api.get('/keychains');
    return result.data;
};

/**
 * Obtiene una Clave, por su ID.
 *
 * @param {string} id - el Id de la Clave
 * @returns {Promise<KeyChains>} Promise - una promesa con el estado del servicio // Error
 */
const getOneKey = async (id) => {
    const result = await Api.get(`/keychains/${id}`);
    return result.data;
};

/**
 * Guarda una Clave
 *
 * @param {object} keyChain - un objeto con los datos de la Clave a guardar
 * @returns {Promise<KeyChains>} Promise - una promesa con el estado del servicio // Error
 */
const saveKey = async (keyChain) => {
    const result = await Api.post('/keychains', keyChain);
    return result.data;
};

/**
 * Actualiza una Clave
 *
 * @param {string} id - el Id de la Clave
 * @param {object} keyChain - un objeto con los datos de la Clave a actualizar
 * @returns {Promise<KeyChains>} Promise - una promesa con el estado del servicio // Error
 */
const updateKey = async (id, keyChain) => {
    const result = await Api.put(`/keychains/${id}`, keyChain);
    return result.data;
};

/**
 * Elimina una Clave
 *
 * @param {string} id - el Id de la Clave
 * @returns {Promise<KeyChains>} Promise - una promesa con el estado del servicio // Error
 */
const deleteKey = async (id) => {
    const result = await Api.delete(`/keychains/${id}`);
    return result.data;
};


export {
    getAllKeys,
    getOneKey,
    saveKey,
    updateKey,
    deleteKey,
};
